/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { editReport, deleteReport, getAndRunReport } from 'state/actions/reportsState/reports_status';
import { createReport } from 'state/actions/reportsState/selected_report_status';
// component
import LibraryPage from 'pages/dashboard/reports/library/library';



/* ========== ~~~~~~~~~~ REPORT LIBRARY : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ reportsState, sessionStatus }) => ({
    accountUUID: sessionStatus.accountUUID,
    userFirstName: sessionStatus.userFirstName,
    isDataReceived: reportsState.reportsStatus.isDataReceived,
    clientReports: reportsState.reportsStatus.clientReports,
    isLibraryProcessing: reportsState.reportsStatus.isLibraryProcessing,
    reportsState
});

// map actions
const mapDispatchToProps = dispatch => ({
	moveToPage: (location) => {
		dispatch(updatePageDetails(location));
    	dispatch(changePage(location))
    },
    createReport: () => dispatch(createReport()),
    editReport: reportUUID => dispatch(editReport(reportUUID)),
    deleteReport: (reportUUID,accountUUID) => dispatch(deleteReport(reportUUID, accountUUID)),
    getAndRunReport: reportUUID => dispatch(getAndRunReport(reportUUID))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(LibraryPage);
